import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, Observable, of } from 'rxjs';
import { catchError, map, share, shareReplay } from 'rxjs/operators';

type OnlineNetworkStatus = 'online';
type OfflineNetworkStatus = 'offline';
export type NetworkStatus = OnlineNetworkStatus | OfflineNetworkStatus;

@Injectable({
  providedIn: 'root',
})
export class IsDeviceOnlineService {
  constructor(private readonly _http: HttpClient) {}

  private readonly _networkStatus = new BehaviorSubject<NetworkStatus>(
    localStorage.getItem('last-stored-network-status') === null
      ? 'offline'
      : (localStorage.getItem('last-stored-network-status') as NetworkStatus)
  );

  private readonly _isOnline$: Observable<OnlineNetworkStatus> = fromEvent(
    window,
    'online'
  ).pipe(
    map(() => {
      this._networkStatus.next('online');
      localStorage.setItem('last-stored-network-status', 'online');
      return 'online';
    })
  );

  private readonly _isOffline$: Observable<OfflineNetworkStatus> = fromEvent(
    window,
    'offline'
  ).pipe(
    map(() => {
      this._networkStatus.next('offline');
      localStorage.setItem('last-stored-network-status', 'offline');
      return 'offline';
    })
  );

  get currentNetwork() {
    return this._networkStatus.getValue();
  }

  private readonly _getInitialNetworkStatus$ = this._http
    .get('https://api64.ipify.org?format=json', {
      observe: 'response',
      headers: { 'skip-interceptor': 'true' },
    })
    .pipe(
      map((response) => {
        if (response.status === 200 || response.ok) {
          this._networkStatus.next('online');
          localStorage.setItem('last-stored-network-status', 'online');
          return 'online' as OnlineNetworkStatus;
        } else {
          this._networkStatus.next('offline');
          localStorage.setItem('last-stored-network-status', 'offline');
          return 'offline' as OfflineNetworkStatus;
        }
      }),
      catchError(() => of('offline' as OfflineNetworkStatus))
    );

  public readonly networkStatus$: Observable<NetworkStatus> = merge(
    // this._fakeNetworkStatusForDevelopment$,
    this._isOnline$,
    this._isOffline$,
    this._getInitialNetworkStatus$
  ).pipe();
}
